import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { motion } from 'framer-motion';
export function BeforeAfterSection() {
  const {
    t
  } = useLanguage();
  const cases = [{
    id: 1,
    image: 'https://cdn.magicpatterns.com/uploads/uHBiRSyre55tTiR78HKDtt/S__3473420.jpg',
    alt: 'Before & After - Nasolabial Folds Treatment'
  }, {
    id: 2,
    image: 'https://cdn.magicpatterns.com/uploads/rtztYQmrMRgd9eV6nZdGYR/S__3473421.jpg',
    alt: 'Before & After - Facial Contouring'
  }, {
    id: 3,
    image: 'https://cdn.magicpatterns.com/uploads/r3iGvu4V7uKzZv6N2SyFr9/S__3473422.jpg',
    alt: 'Before & After - Skin Rejuvenation'
  }, {
    id: 4,
    image: 'https://cdn.magicpatterns.com/uploads/vsFTrnUQh7uz7txA1x4vSh/BF2.jpg',
    alt: 'Before & After - Singderm Filler Case'
  }];
  return <section id="before-after" className="py-24 bg-brand-bg" data-id="element-53">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-54">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-55">
          <h2 className="text-sm font-bold tracking-widest text-brand-copper uppercase mb-3" data-id="element-56">
            {t('beforeAfter.label')}
          </h2>
          <h3 className="text-3xl md:text-4xl font-light text-gray-900 mb-6" data-id="element-57">
            {t('beforeAfter.title1')}{' '}
            <span className="font-semibold" data-id="element-58">{t('beforeAfter.title2')}</span>
          </h3>
          <p className="text-gray-600" data-id="element-59">{t('beforeAfter.subtitle')}</p>
        </div>

        {/* Cases Gallery */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto" data-id="element-60">
          {cases.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-61">
              <div className="aspect-[3/4] overflow-hidden" data-id="element-62">
                <img src={item.image} alt={item.alt} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-63" />
              </div>
              <div className="p-4 flex justify-center gap-4" data-id="element-64">
                <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded text-xs font-semibold tracking-wider" data-id="element-65">
                  {t('beforeAfter.before')}
                </span>
                <span className="bg-brand-copper text-white px-3 py-1 rounded text-xs font-semibold tracking-wider" data-id="element-66">
                  {t('beforeAfter.after')}
                </span>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-67">
          <p className="text-sm text-gray-500 italic" data-id="element-68">
            {t('beforeAfter.disclaimer')}
          </p>
        </div>
      </div>
    </section>;
}